import { call, put, takeLatest } from 'redux-saga/effects'
import { defineTypes } from '../../helpers'
import InventoryEndpoint from '../../persistence/InventoryEndpoint'
import { reduxFetch } from '../../http/reduxFetch'
import Alert from 'react-s-alert';

const createInventoryTypes = { ...defineTypes('CREATE_INVENTORY')  }
const destroyInventoryTypes = { ...defineTypes('DESTROY_INVENTORY') }
const inventoryTypes = { ...defineTypes('INVENTORY') }

export const initialState = {
  loading: false,
  loaded: false,
}

export const actions = {
  createInventory (product_id, keg_size_id, options) {
    return {
      type: createInventoryTypes.REQUEST,
      id: product_id,
      keg_size_id: keg_size_id,
      post_request: options.post_request,
      inventory_type: options.inventory_type
    }
  },
  destroyInventory( product_id, keg_size_id, options) {
    return {
      type: destroyInventoryTypes.REQUEST,
      id: product_id,
      keg_size_id: keg_size_id,
      inventory_type: options.inventory_type,
      post_request: options.post_request
    }
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case createInventoryTypes.REQUEST:
      return { ...state, started: true, loading: true }
    case createInventoryTypes.FAILURE:
      return { ...state, loading: false, error: action.error }
    case createInventoryTypes.SUCCESS:
      return { ...state, loading: false, loaded: true, created: true }
    case destroyInventoryTypes.REQUEST:
      return { ...state, started: true, loading: true }
    case destroyInventoryTypes.FAILURE:
      return { ...state, loading: false, error: action.error }
    case destroyInventoryTypes.SUCCESS:
      return { ...state, loading: false, loaded: true, destroyed: true}
    default:
      return state
  }
}
export const selectors = {
  inventory_state: (store) => {
    return store.inventoryUpdateReducer
  },
  loaded: (store) => {
    return store
      && store.inventoryUpdateReducer
      && store.inventoryUpdateReducer.loaded
  }
}

export function * createInventorySaga (action) {
  try {
    const form = {}
    form['product_id'] =  action.id
    form['keg_size_id'] = action.keg_size_id
    form['inventory_type'] = action.inventory_type


    let response = yield call(reduxFetch, InventoryEndpoint.create(form))

    if (response['data']) {
      yield put({ type: createInventoryTypes.SUCCESS })
      yield put({ type: inventoryTypes.REQUEST })
      yield call(Alert.success, '<div>Inventory Added</div>')
      yield put({...action.post_request})
    } else {
      yield put({ type: createInventoryTypes.FAILURE, error: response['error'] })
    }
  } catch (error) {
    yield put({ type: createInventoryTypes.FAILURE, error })
  }
}

export function * destroyInventorySaga (action) {
  try {
    const form = {}
    form['product_id'] =  action.id
    form['keg_size_id'] = action.keg_size_id
    form['inventory_type'] = action.inventory_type

    let response = yield call(reduxFetch, InventoryEndpoint.destroy(form))

    if (response['data']) {
      yield put({ type: destroyInventoryTypes.SUCCESS })
      yield put({ type: inventoryTypes.REQUEST })
      yield call(Alert.success, '<div>Inventory Removed</div>')
      yield put({...action.post_request})
    } else {
      yield put({ type: destroyInventoryTypes.FAILURE, error: response['error'] })
    }
  } catch (error) {
    yield put({ type: destroyInventoryTypes.FAILURE, error })
  }
}

export function * rootSaga () {
  yield takeLatest(createInventoryTypes.REQUEST, createInventorySaga)
  yield takeLatest(destroyInventoryTypes.REQUEST, destroyInventorySaga)
}




// WEBPACK FOOTER //
// ./src/sagas/inventory/new.js